import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
import IconClose from "../../assets/icons/icon-close.svg";
import Logo from "../../assets/images/logo.svg";
import { isEmpty } from "../../helpers/functions";
import UserBalance from "./header/Actions/UserBalance";
import { USER_NAV } from "../../routes/APP_ROUTES";
import { useTranslation } from "react-i18next";

const MobileNavigation = ({ isMenuOpen, setIsMenuOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMenu, setIsMenu] = useState(true);

  const { user } = useAuth();
  const isUserRole = user && user.role === "User";
  const handleNavigation = (e, path) => {
    e.preventDefault();
    setIsMenuOpen(false); // Close menu when navigating
    if (isMenu) {
      navigate(path);
    } else {
      navigate(`/user/${path}`);
    }
  };
  const userNav = USER_NAV();

  const APP_NAV = [
    ...((user && user.role === "User") || isEmpty(user)
      ? [
          {
            path: "/sportsbook/sports",
            label: t("SPORTS BETTING"),
            id: "sports",
          },
          { path: "/sportsbook/live", label: t("LIVE"), id: "live" },
        ]
      : []),
    { path: "/livecasino", label: t("LIVE CASINO"), id: "livecasino" },
    { path: "/casino/slots", label: "CASINO", id: "casino" },

    // { path: "/live-games/:id", label: t("LIVE GAMES"), id: "games" },

    { path: "/virtuals", label: t("VIRTUALS"), id: "virtuals" },
    // { path: "/promotions", label: t("PROMOTION"), id: "promotions" },
  ];

  return (
    <>
      <style jsx="true">{`
        nav a.active svg,
        nav a:hover svg {
          fill: white !important;
        }
      `}</style>

      <div
        className={`fixed top-0 right-0 h-screen w-full bg-[#46485c] text-white transform overflow-y-auto ${
          isMenuOpen ? "translate-y-0" : "translate-y-full"
        } transition-transform duration-300 ease-in-out z-50 shadow-lg`}
      >
        {/* Header Section */}
        <div className="bg-[#191820] flex justify-center items-center px-2 py-2 border-b border-gray-700 relative">
          <div className="w-32">
            <Link className="flex h-headerLogoMobileHeight ltr:mr-1.5 rtl:ml-1.5" top="/home">
              <img src={Logo} alt="logo" />
            </Link>
          </div>
          <button className="text-white text-2xl pr-2 absolute right-3" onClick={() => setIsMenuOpen(false)}>
            <img alt="Close" src={IconClose} />
          </button>
        </div>
        {!user ? (
          <>
            <span
              className={`py-3 flex-1 px-3 flex items-center justify-center text-sm font-semibold border-b-2  ${
                isMenu ? "border-primary text-white" : "border-[#313346] text-white/70"
              }`}
              onClick={() => setIsMenu(true)}
            >
              Main Menu{" "}
            </span>
            <nav>
              {APP_NAV.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.path}
                  onClick={(e) => handleNavigation(e, item.path)}
                  className={({ isActive }) => `flex items-center gap-2 p-3 text-white border-b border-[#313346] ${isActive ? " bg-primary" : ""}`}
                >
                  {item.icon}
                  <span className="text-center ml-1">{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </>
        ) : (
          <>
            <div className="p-5">
              <div className="bg-primary rounded-xl p-2">
                <UserBalance isMobileNav user={user} />
              </div>
            </div>
            {isUserRole && (
              <div className="py-4">
                {/* Casino Section */}
                <>
                  <div className="flex border-t border-white/10">
                    <span
                      className={`py-3 flex-1 px-3 flex items-center justify-center text-sm font-semibold border-b-2  ${
                        isMenu ? "border-primary text-white" : "border-[#313346] text-white/70"
                      }`}
                      onClick={() => setIsMenu(true)}
                    >
                      Main Menu{" "}
                    </span>
                    <span
                      className={` flex-1 py-2 px-3 flex items-center justify-center text-sm font-semibold border-b-2 ${
                        !isMenu ? "border-primary text-white" : "border-[#313346] text-white/70"
                      }`}
                      onClick={() => setIsMenu(false)}
                    >
                      User Menu
                    </span>
                  </div>
                  {isMenu ? (
                    <nav>
                      {APP_NAV.map((item, index) => (
                        <NavLink
                          key={index}
                          to={item.path}
                          onClick={(e) => handleNavigation(e, item.path)}
                          className={({ isActive }) =>
                            `flex items-center gap-2 p-3 text-white border-b border-[#313346] ${isActive ? " bg-primary" : ""}`
                          }
                        >
                          {item.icon}
                          <span className="text-center ml-1">{item.label}</span>
                        </NavLink>
                      ))}
                    </nav>
                  ) : (
                    <nav>
                      {userNav
                        .filter((fi) => (isUserRole ? fi : []))
                        .map((item, index) => (
                          <NavLink
                            key={index}
                            to={`/user/${item.path}`}
                            onClick={(e) => handleNavigation(e, item.path)}
                            className={({ isActive }) =>
                              `flex items-center gap-2 py-2 px-3 font-semibold ${isActive ? " bg-primary text-white" : ""}`
                            }
                          >
                            {item.icon}
                            <span>{item.label}</span>
                          </NavLink>
                        ))}
                    </nav>
                  )}
                </>
              </div>
            )}
          </>
        )}
      </div>

      {/* Backdrop when Menu is Open */}
      {isMenuOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsMenuOpen(false)}></div>}
    </>
  );
};

export default MobileNavigation;
